<section class="card excluded-countries col-sm-12" *ngIf="!isError">
  <h5 class="center">{{ 'excludedCountries' | translate }}</h5>
  <div class="row countries-list">
    <ng-container *ngIf="(excludedCountries$ | async) === false">
      <div class="col-6 col-sm-6 col-md-5 col-lg-3" *ngFor="let skeleton of [1, 2, 3, 4]">
        <div class="skeleton"></div>
      </div>
    </ng-container>
    <div class="col-6 col-sm-6 col-md-5 col-lg-3" *ngFor="let country of (excludedCountries$ | async)">
      <span>{{ country | masterDataTranslate | async }}</span>
    </div>
  </div>
</section>
